export default "__VITE_ASSET__Mxdt8Jzk__"